/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Btn_Export_GpxInputs */

const en_ui_btn_export_gpx = /** @type {(inputs: Ui_Btn_Export_GpxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export as GPX`)
};

const de_ui_btn_export_gpx = /** @type {(inputs: Ui_Btn_Export_GpxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als GPX exportieren`)
};

/**
* | output |
* | --- |
* | "Export as GPX" |
*
* @param {Ui_Btn_Export_GpxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_btn_export_gpx = /** @type {((inputs?: Ui_Btn_Export_GpxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Btn_Export_GpxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_btn_export_gpx(inputs)
	return de_ui_btn_export_gpx(inputs)
});